import { render, staticRenderFns } from "./editorbanben.vue?vue&type=template&id=4673799c&scoped=true"
import script from "./editorbanben.vue?vue&type=script&lang=js"
export * from "./editorbanben.vue?vue&type=script&lang=js"
import style0 from "./editorbanben.vue?vue&type=style&index=0&id=4673799c&prod&lang=css"
import style1 from "./editorbanben.vue?vue&type=style&index=1&id=4673799c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673799c",
  null
  
)

export default component.exports